import { BoxProps, useDisclosure } from "@chakra-ui/react"
import CustomTooltip from "./CustomTooltip"
import { CInfo } from "./Icons"

type Props = BoxProps & {
  tooltipLabel: string
}

const InfoIcon = ({ tooltipLabel, maxW }: Props) => {
  /* This makes a controlled tooltip so it shows on touch on mobile */
  const { isOpen, onOpen, onToggle, onClose } = useDisclosure()

  return (
    <CustomTooltip label={tooltipLabel} isOpen={isOpen} gutter={12} maxW={maxW}>
      <CInfo onMouseEnter={onOpen} onMouseLeave={onClose} onClick={onToggle} />
    </CustomTooltip>
  )
}

export default InfoIcon
